import { ref, nextTick } from 'vue';
import debounce from 'lodash/debounce';

export function useObserver(listItems) {
    const observer = ref(null);

    const toggleRowClass = (element, addClass, removeClass) => {
        element.classList.add(addClass);
        element.classList.remove(removeClass);
    };

    const createObserver = () => {
        observer.value = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    toggleRowClass(entry.target, 'highlight-row', 'dim-row');
                } else {
                    toggleRowClass(entry.target, 'dim-row', 'highlight-row');
                }
            });
        });
    };

    const observeElements = () => {
        nextTick(() => {
            const container = listItems.value[0]?.$el?.parentElement;
            if (container) {
                observer.value.observe(container);
            }

            // Agregar la clase 'highlight-row' a los tres primeros elementos
            listItems.value.slice(0, 3).forEach((item) => {
                const element = item?.$el;
                if (element) {
                    toggleRowClass(element, 'highlight-row', 'dim-row');
                }
            });
        });
    };

    const handleScroll = debounce(() => {
        const rows = listItems.value;
        const windowHeight = window.innerHeight;

        rows.forEach((row, index) => {
            const element = row?.$el;
            if (element) {
                const rect = element.getBoundingClientRect();
                if (index === 0 || (rect.top >= 0 && rect.bottom <= windowHeight)) {
                    toggleRowClass(element, 'highlight-row', 'dim-row');
                } else {
                    toggleRowClass(element, 'dim-row', 'highlight-row');
                }
            }
        });
    }, 100);

    return {
        observer,
        createObserver,
        observeElements,
        handleScroll
    };
}